import React from 'react'
import { Row, Col, Container } from 'react-bootstrap'
import { StaticQuery, graphql } from 'gatsby'
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from 'styled-components'

class CantidadSSL extends React.Component {


    shouldComponentUpdate() {
        return false
    }


    render() {
        const Section = styled.section`
            position: relative;
            overflow: hidden;
            background-color: #000;            
            background-size: cover;
            padding: 100px 0 50px 0;
            .heading {
                width: 100%;
            }
            @media (max-width: 767px) {
                padding: 10px 0 20px 0;           
            }
            @media (min-width:768px) and (max-width:1500px) {
                padding: 150px 0 50px 0;              
            }
          }
        `

        const ServiceContainer = styled.div`
            background-color: rgba(0,0,0,.9);
            padding: 60px 0;
        `


        const ServiceElement = styled.div`
            margin-bottom: 20px;
            text-align: center;
            padding: 40px;
            border-radius: 20px;
            transition: .2s;
            &:hover {
                background-color: #000;
                box-shadow: 0 28px 60px rgb(193, 235, 24, .4);
                transform: translateY(-10px);
            }
        `
        const ServiceHeading = styled.h3`
            font-size: 30px;
            font-weight: 500;
            font-family: Teko;
            color: #fff;
        `
        const ServiceSeparator = styled.div`
            height: 5px;
            width: 50px;
            background-color: #c1eb18;
            margin: auto auto 10px auto;        
         `
        const ServiceIcon = styled.div`
      margin-bottom: 20px;
      img {
        max-height: 70px;
        max-width: 70px;
        width: 100%;
        height: auto;
      }
    `

        const ServiceText = styled.p`
            font-size: 16px;
            font-weight: 300;
            color: #c5c5c5;
            padding-right: 25px;
            text-align: left;           
        `

        const Text = styled.p`
            font-size: 18px;
            font-weight: 300;
            color: #ffffff;
            padding-bottom: 50px;
            text-align: center;          
        `

        const Color = styled.span`            
            font-weight: bold;
            color: #c1eb18;            
        `

        const Color2 = styled.span`            
            font-weight: bold;
        `
        const Color3 = styled.span`          
          color: #c1eb18;
          font-family: "Teko", sans-serif;            
        `

        const Heading2 = styled.h2`
            transform: translate(0, -100px);            
            transition: 1s;
            margin-top: 100px;            
            font-size: 50px;
            line-height: 50px;
            font-family: "Teko", sans-serif;
            font-weight: 500;
            color: #fff;
            text-align: center;
        `

        return (
            <Section>
                <ServiceContainer>
                    <Container>
                        <Heading2>Asegurando tus <Color3>dominios y subdominios</Color3></Heading2>
                        <Text>
                            Ya sea que necesites proteger un solo dominio, varios dominios o subdominios ilimitados, en VASCO Solutions tenemos la solución
                            perfecta para ti. Nuestros certificados SSL ofrecen la máxima seguridad y confianza para tus sitios o aplicaciones web, garantizando la protección
                            de la información confidencial y la tranquilidad de tus usuarios.
                        </Text>
                        <Row>
                            <Col md={4}>
                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image1} alt="SSL para asegurar 1 dominio" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        SSL para un único dominio
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        Si tienes un <Color2>(1)</Color2> solo dominio o subdominio que necesitas proteger, un Certificado SSL para un solo dominio es la opción ideal. Este certificado
                                        te permite asegurar <Color>un único dominio,</Color> proporcionando seguridad confiable y protección para tu sitio web principal.
                                    </ServiceText>
                                </ServiceElement>
                            </Col>
                            <Col md={4}>
                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image2} alt="SAN SSL Flex" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        SSL para varios dominios
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        ¿Tienes <Color2>varios</Color2> sitios web con diferentes dominios o subdominios que necesitas proteger? ¡No hay problema! Con un <Color>Certificado SSL
                                            Multidominio</Color> o <Color>SAN</Color> <Color2>(Subject Alternative Name)</Color2> o <Color>UCC</Color> <Color2>(Unified Communication Certificates),</Color2> puedes asegurar <Color>múltiples
                                                dominios o subdominios</Color> con un solo certificado. Esto te brinda una solución conveniente y rentable para proteger todos tus sitios web bajo una misma seguridad SSL.
                                    </ServiceText>
                                </ServiceElement>
                            </Col>
                            <Col md={4}>
                                <ServiceElement>
                                    <ServiceIcon>
                                        <GatsbyImage image={this.props.image3} alt="SSL Wildcard" />
                                    </ServiceIcon>
                                    <ServiceHeading>
                                        SSL para subdominios ilimitados
                                    </ServiceHeading>
                                    <ServiceSeparator />
                                    <ServiceText>
                                        ¿Gestionas una red de sitios web con <Color2>numerosos subdominios?</Color2> Un <Color>Certificado SSL Wildcard</Color> es la solución perfecta. Con este certificado, puedes
                                        asegurar tu <Color>dominio principal y todos sus subdominios ilimitados</Color> bajo una sola protección SSL. ¡Así de simple y seguro!
                                    </ServiceText>
                                </ServiceElement>
                            </Col>
                        </Row>
                    </Container>
                </ServiceContainer>
            </Section>
        )
    }

}

const Iconos = (props) => (
    <StaticQuery
        query={graphql`
        {          
          image1: file(relativePath: { eq: "icons/privacidad.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image2: file(relativePath: { eq: "icons/inverse.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }
          image3: file(relativePath: { eq: "icons/private.png" }) {
            childImageSharp {
              gatsbyImageData(
              layout: CONSTRAINED
              placeholder: DOMINANT_COLOR
              quality: 80
              formats: [AUTO, WEBP, AVIF]
              width: 70
            )
            }
          }          
        }
      `}
        render={(data) => {
            const image1 = getImage(data.image1.childImageSharp.gatsbyImageData);
            const image2 = getImage(data.image2.childImageSharp.gatsbyImageData);
            const image3 = getImage(data.image3.childImageSharp.gatsbyImageData);
            return <CantidadSSL data={data} image1={image1} image2={image2} image3={image3}{...props} />;
        }}
    />
);

export default Iconos;
